import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
interface ToastProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
}
export function Toast({
  message,
  isVisible,
  onClose
}: ToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 animate-in slide-in-from-bottom-5 fade-in duration-300" data-id="element-525">
      <div className="bg-gray-900 text-white px-6 py-3 rounded-full shadow-xl flex items-center gap-3 min-w-[300px] justify-center" data-id="element-526">
        <CheckCircle className="w-5 h-5 text-green-400" data-id="element-527" />
        <span className="font-medium text-sm" data-id="element-528">{message}</span>
      </div>
    </div>;
}